import React, { useEffect, useState } from "react";

// ASSETS

// STYLES
import {
  ReportsSectionActivityCardButtonWrapper,
  ReportsSectionActivityCardContainer,
  ReportsSectionActivityCardTextWrapper,
  ReportsSectionActivityCardTitleWrapper,
  ReportsSectionActivityCardWrapper,
  ReportsSectionContainer,
  ReportsSectionContentWrapper,
  ReportsSectionIcon,
  ReportsSectionReportCardIcon,
  ReportsSectionReportCardIconWrapper,
  ReportsSectionReportCardTitleWrapper,
  ReportsSectionReportCardWrapper,
  ReportsSectionReportsContainer,
} from "./ReportsSectionStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "../AboutPageModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { appRoutes } from "config/AppRoutesConfig";
import aboutService from "services/aboutService";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const ReportsSection = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [reports, setReports] = useState<any>(null);

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getActivityReports()
      .then((response) => {
        // console.log("getReports response", response);
        setReports(response);
      })
      .catch((err) => {
        console.log("getReports error", err);
      });
  }, []);

  // EVENT HANDLERS
  const handleClick = () => {
    navigate(appRoutes.activityReports);
  };

  // Sort and slice reports
  const sortedReports = reports?.data
    ?.sort(
      (a, b) =>
        new Date(b.attributes.createdAt).getTime() -
        new Date(a.attributes.createdAt).getTime()
    )
    ?.slice(0, 6);

  return (
    <ReportsSectionContainer>
      <ReportsSectionContentWrapper>
        <ReportsSectionIcon />
        <ReportsSectionActivityCardContainer>
          <ReportsSectionActivityCardWrapper>
            <ReportsSectionActivityCardTitleWrapper>
              <CustomText
                text={t("view.about.aboutDSU.reportsSection.title")}
                type={TextType.H2}
                color={COLORS.Cultured}
              />
            </ReportsSectionActivityCardTitleWrapper>
            <ReportsSectionActivityCardTextWrapper>
              <CustomText
                text={t("view.about.aboutDSU.reportsSection.text")}
                type={TextType.P2}
                color={COLORS.Cultured}
              />
            </ReportsSectionActivityCardTextWrapper>
            <ReportsSectionActivityCardButtonWrapper>
              <ButtonAtom
                text={t("view.about.aboutDSU.reportsSection.buttonText")}
                type={ButtonType.Link}
                rightIcon={true}
                onClick={handleClick}
              />
            </ReportsSectionActivityCardButtonWrapper>
          </ReportsSectionActivityCardWrapper>
          <ReportsSectionReportsContainer>
            {sortedReports?.map((report, index) => (
              <ReportsSectionReportCardWrapper
                key={index}
                href={`${process.env.REACT_APP_UPLOAD_URL}${report?.attributes?.documents?.data[0]?.attributes?.attached_document?.data?.attributes?.url}`}
                target={"_blank"}
              >
                <ReportsSectionReportCardTitleWrapper>
                  <CustomText
                    text={`Raport ${report?.attributes?.year}`}
                    type={TextType.H4}
                    color={COLORS.RaisinBlack}
                  />
                </ReportsSectionReportCardTitleWrapper>
                <ReportsSectionReportCardIconWrapper>
                  <ReportsSectionReportCardIcon />
                </ReportsSectionReportCardIconWrapper>
              </ReportsSectionReportCardWrapper>
            ))}
          </ReportsSectionReportsContainer>
        </ReportsSectionActivityCardContainer>
      </ReportsSectionContentWrapper>
    </ReportsSectionContainer>
  );
};

export default ReportsSection;
